module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-188.7fee5272.svg";